import { AbstractCommand } from 'src/models/command';

class MailSpamByAggregateIdsCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_SpamTheSelectedAggregateIds';

	public constructor(aggregateIds: string[], processId: string) {
		super();
		this.processId = processId;
		this.parameters = {
			aggregateIds: aggregateIds,
		};
	}
}

export { MailSpamByAggregateIdsCommand };
